import script from "./CreateProductCategoryDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./CreateProductCategoryDialog.vue?vue&type=script&setup=true&lang=js"

import "./CreateProductCategoryDialog.vue?vue&type=style&index=0&id=61d14bc2&lang=css"
import "./CreateProductCategoryDialog.vue?vue&type=style&index=1&id=61d14bc2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-61d14bc2"]])

export default __exports__